import { __decorate } from "tslib";
import { NgModule } from 'angular-ts-decorators';
import { BreadcrumbsComponent } from './breadcrumbs-dynamic/breadcrumbs-dynamic.component';
var moduleId = 'gn.audio.support.breadcrumbs';
var BreadcrumbsModule = (function () {
    function BreadcrumbsModule() {
    }
    BreadcrumbsModule = __decorate([
        NgModule({
            declarations: [BreadcrumbsComponent],
            id: moduleId,
            imports: [],
            providers: [],
        })
    ], BreadcrumbsModule);
    return BreadcrumbsModule;
}());
export { BreadcrumbsModule };
